import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateTimerUseCase {
    invoke: (itemId: number, data: any) => Promise<boolean>;
  }
  
  export class UpdateTimer implements UpdateTimerUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(itemId: number, data: any){
       
        if(!itemId){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateTimer(itemId, data);
        return update;
    }
  }